import type { ReactNode } from 'react';

import { useEffect, useMemo, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { superHubStore } from '@core/store';
import usePersistHashOverlays from '@routes/SuperHub/hooks/usePersistHashOverlays';

import SuperHubContext, { SuperHubActionSlotContext } from '.';

export interface SuperHubContextProviderProps {
  children: ReactNode;
}

export function SuperHubContextProvider({ children }: SuperHubContextProviderProps) {
  const browserRouterHistory = useHistory();
  const browserRouterLocation = useLocation();

  useEffect(() => {
    superHubStore.getState().registerBrowserRouterHistory(browserRouterHistory);
    return () => superHubStore.getState().registerBrowserRouterHistory(null);
  }, [browserRouterHistory]);

  usePersistHashOverlays(browserRouterHistory);

  const [actionSlot, setActionSlot] = useState<HTMLDivElement | null>(null);

  return (
    <SuperHubContext.Provider
      value={useMemo(
        () => ({
          browserRouterHistory,
          browserRouterLocation,
          setActionSlot,
        }),
        [browserRouterHistory, browserRouterLocation],
      )}
    >
      <SuperHubActionSlotContext.Provider value={actionSlot}>{children}</SuperHubActionSlotContext.Provider>
    </SuperHubContext.Provider>
  );
}
